import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return null; // or a loading spinner
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    // Week 4: Client Portal Foundation - Redirect client users to client portal
    if (user.role === 'client') {
        return <Navigate to="/client-portal" />;
    }

    return children;
};

export default PrivateRoute; 